/**
 * @file PlusCircle.jsx
 * @description plus sign surrounded by a circle.
 * @exports PlusCircle
 */
import React from 'react'

const defaultColor = '#284047'

const PlusCircle = ({ color = defaultColor }) => {
  return (
    <svg
      id='alert-icon-circle'
      preserveAspectRatio='xMidYMid meet'
      viewBox='0 0 75 75'
      height='50'
      width='50'
    >
      <description>plus circle icon</description>
      <title>add</title>
      <g
        style={{
          transform: 'translate(11px, 12px) scale(.4)',
        }}
      >
        <circle cx='64' cy='64' r='58' fill='none' stroke={color} strokeWidth='8px' />
        <g>
          <line x1='24' y1='64' x2='104' y2='64' stroke={color} strokeWidth='16px' />
          <line x1='64' y1='24' x2='64' y2='104' stroke={color} strokeWidth='16px' />
        </g>
      </g>
    </svg>
  )
}

export default PlusCircle
